import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subscriber} from 'rxjs/Subscriber';

enum NfcReaderStatus { available, disabled, notSupported }

@Injectable()
export class NfcServiceProvider {
  private tagDataSubscriber: Subscriber<string>;
  private tagRead: Observable<string> = new Observable<string>(
    observer => this.tagDataSubscriber = observer
  );
  private nfcReaderSubscriber: Subscriber<boolean>;
  private nfcReaderReportObserver: Observable<boolean> = new Observable<boolean>(
    observer => this.nfcReaderSubscriber = observer
  );
  private isAndroidSubscriber: Subscriber<boolean>;
  private isAndroidReportObserver: Observable<boolean> = new Observable<boolean>(
    observer => this.isAndroidSubscriber = observer
  );

  // called by Flutter if Tag was detected
  public TagDetected(nfcTag: string) {
    this.tagDataSubscriber.next(nfcTag);
  }

  public get TagRead(): Observable<string> {
    let proxy = this.window["ReadNfcOnce"];
    if (proxy !== undefined) {
      proxy.postMessage("");
    } else {
      if (this.tagDataSubscriber) {
        this.tagDataSubscriber.next(null);
      }
    }
    return this.tagRead;
  }

  public StartRead() {
    let proxy = this.window["ReadNfcOnce"];
    if (proxy !== undefined) {
      proxy.postMessage();
    }
  }

  // called by Flutter to report the NFC status
  public ReportNfcStatus(status: NfcReaderStatus) {
    this.nfcReaderSubscriber.next(status == NfcReaderStatus.available);
  }

  public get RequestNfcStatus(): Observable<boolean> {
    let proxy = this.window["RequestInternalNfcAvailability"];
    if (proxy !== undefined) {
      proxy.postMessage("");
    } else {
      if (this.nfcReaderSubscriber) {
        this.nfcReaderSubscriber.next(false);
      }
    }
    return this.nfcReaderReportObserver;
  }

  // called by Flutter to report device type
  // see https://gist.github.com/adamawolf/3048717 for Apple devices
  public DeviceType(deviceType: string) {
    this.isAndroidSubscriber.next(!deviceType.includes("iPhone") && !deviceType.includes("iPad"));
  }

  public get IsAndroid(): Observable<boolean> {
    let proxy = this.window["RequestDeviceType"];
    if (proxy !== undefined) {
      proxy.postMessage("");
    } else {
      if (this.isAndroidSubscriber) {
        this.isAndroidSubscriber.next(true);
      }
    }
    return this.isAndroidReportObserver;
  }

  constructor(@Inject('Window') private window: any) {
    this.window["NfcServiceProvider"] = this;
  }
}



// WEBPACK FOOTER //
// ./src/providers/nfc-service/nfc-service.ts